<template>
  <div :id="$attrs['id']"
       :class="[$attrs['class'], { 'card__inner--no-padding': fullSize}]"
       :style="style"
       class="card__inner">
    <div v-if="!isEmpty(title) || deletable" :class="[{'card__inner__info--has-icon': !isNil(icon) || collapsible}, {'card__inner__info--collapsible': collapsible && !collapseLocked}]" class="card__inner__info" @click="onClickTitle">
      <template v-if="collapsible">
        <icon :class="['card__inner__info__icon--collapse', {'card__inner__info__icon--open': isOpen}]" icon="collapse" />
      </template>
      <icon v-if="!isNil(icon)" :icon="icon" />
      <div v-if="!isEmpty(title)"
           :class="[{ 'card__inner__info__title--clickable': titleClickable }]"
           :title="title"
           class="card__inner__info__title"
           v-html="title"/>
      <div v-if="deletable" class="card__inner__info__delete" @click="handleClickDelete($event)">
        <icon icon="close"></icon>
      </div>
    </div>
    <template v-if="!collapsible || (collapsible && isOpen)">
      <slot />
    </template>
    <div v-if="disabled" class="card__inner__overlay__disabled" />
  </div>
</template>

<script>

import { isNil, isEmpty } from 'lodash';
import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';

export default {
  name: 'HmCardInner',

  mixins: [GridMixin, HotelmeisterMixin],

  props: {
    title: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    deletable: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullSize: {
      type: Boolean,
      required: false,
      default: false,
    },
    minHeight: {
      type: String,
      required: false,
      default: null,
    },
    titleClickable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsible: {
      type: Boolean,
      required: false,
      default: false,
    },
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapseLocked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data: function () {
    return {
      isOpen: this.open,
    };
  },

  computed: {
    style: function () {
      if (isEmpty(this.minHeight)) return { };

      return {
        minHeight: this.minHeight,
      };
    },
  },

  methods: {
    handleClickDelete: function (event) {
      event.stopPropagation();
      this.$emit('delete', event);
    },
    isNil: function (val) {
      return isNil(val);
    },
    isEmpty: function (val) {
      return isEmpty(val);
    },
    onClickTitle(evt) {
      if (this.collapsible && !this.collapseLocked) this.isOpen = !this.isOpen;
      this.$emit('clickTitle', evt);
      this.addUIBreadcrumb(
        'User clicked card title',
        {
          id: this.$attrs.id,
          name: this.title,
        },
      );
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';
  .card__inner {
    display: grid;
    grid-column-end: span 12;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 1.5rem;
    position: relative;
    padding-bottom: 1rem;
    margin-bottom: 1.5rem;

    &--strike-through-title {
      .card__inner__info__title {
        text-decoration: line-through;
      }
    }
    // z-index: 1;
    &:after {
      content: '';
      position: absolute;
      width: calc(100% + 3rem);
      height: 4px;
      left: -1.5rem;
      right: -1.5rem;
      bottom: 0;
      background-color: $lightgray;
      box-shadow: inset 0 1px 1px 0 $cardinnergray;
    }
    &:last-of-type {
      padding-bottom: 0;
      margin-bottom: 0;
      &:after {
        content: none;
      }
    }
    &__info {
      display: grid;
      grid-template-columns: 1fr 4rem;
      grid-column-end: span 12;
      align-items: center;
      margin-bottom: 1rem;
      &--has-icon {
        grid-template-columns: 3.5rem 1fr 4rem;
      }
      .hm-icon {
        width: 3rem;
        height: 3rem;
        display: inline-block;
      }
      &--collapsible {
        cursor: pointer;
        transition: color 0.2s ease;
        &:hover {
          color: $black;
        }
      }
      &__icon {
        &--open {
          transform: rotate(180deg);
        }
      }
      &__title {
        font-weight: 700;

        &--clickable {
          cursor: pointer;
          text-decoration: underline;
          color: $blue;
        }
      }
      &__delete {
        @include icon-color($middlegray);
        @include icon-hover($text);
        justify-self: end;
        &:hover {
          cursor: pointer;
        }
        .hm-icon {
          width: 3rem;
          height: 3rem;
          display: inline-block;
          position: absolute;
          right: -0.7rem;
          top: -0.7rem;
        }
      }
    }
    &--no-padding {
      padding: 0;
      margin: -1.5rem;
      margin-bottom: 1.5rem;

      .card__inner__info {
        .hm-icon {
          margin-left: 1.5rem;
          margin-top: 1.5rem;
        }
      }

      .card__inner__info__title {
        margin-left: 1.5rem;
        margin-top: 1.5rem;
      }

      &:last-of-type {
        margin-bottom: -1.5rem;
      }

      &:after {
        left: 0;
        right: 0;
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/HmCardInner.vue